import WebsiteBehaviors from "../website-behaviors/index.js";

class JLC extends WebsiteBehaviors {
	identifier() {
		return "JLC";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "jlc.org");
	}

	styles() {
		// language=CSS
		return `
			body {
				height: auto;
			}
		`;
	}
}

export default JLC;
